import { CHANGE_THEME } from './configuration/actions';

// Restore the user's last theme choice on load (falls back to 'light').
const getInitialTheme = () => {
    try {
        const stored = localStorage.getItem('theme');
        return stored === 'dark' || stored === 'light' ? stored : 'light';
    } catch (e) {
        return 'light';
    }
};

export default (previousState = getInitialTheme(), { type, payload }) => {
    if (type === CHANGE_THEME) {
        try {
            localStorage.setItem('theme', payload);
        } catch (e) {
            // ignore storage errors (e.g. private mode)
        }
        return payload;
    }
    return previousState;
};
